import React, { useCallback } from 'react'
import { useMuiSelectUtils } from 'scenes/Dashboard/components-next/Inputs/Select/Select.hook'

import { MenuItem, Select, SelectChangeEvent } from '@mui/material'

import { CorporateStatus } from '../../../../../../entities-next/corporate'

export type CorporateStatusSelectorProps = {
  status?: CorporateStatus
  onChange: (newSearch: CorporateStatus) => void
}

export const CorporateStatusSelector = React.memo(({ onChange, status }: CorporateStatusSelectorProps) => {
  const menuItemsData = React.useMemo(
    () => [
      { value: '', text: 'All status' },
      { value: CorporateStatus.inactive, text: 'Inactive' },
      { value: CorporateStatus.pov, text: 'PoV' },
      { value: CorporateStatus.active, text: 'Active' },
    ],
    []
  )
  const selected = status ?? ''
  const { getItem, selectedItem, setSelectedItem } = useMuiSelectUtils(menuItemsData, selected)

  const onSelectChange = useCallback(
    (event: SelectChangeEvent<{ name?: string; value: unknown }>) => {
      const status = event.target.value as CorporateStatus
      onChange(status)
      setSelectedItem(status)
    },
    [onChange]
  )

  return (
    <Select
      variant="standard"
      onChange={onSelectChange}
      value={getItem(selectedItem)}
      renderValue={() => getItem(selectedItem)?.text}
    >
      {menuItemsData.map((m) => (
        <MenuItem key={m.value} value={m.value}>
          {m.text}
        </MenuItem>
      ))}
    </Select>
  )
})

CorporateStatusSelector.displayName = 'CorporateStatusSelector'
